import { render, staticRenderFns } from "./IconLoop.vue?vue&type=template&id=25338a2c&"
import script from "./IconLoop.vue?vue&type=script&lang=js&"
export * from "./IconLoop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25338a2c')) {
      api.createRecord('25338a2c', component.options)
    } else {
      api.reload('25338a2c', component.options)
    }
    module.hot.accept("./IconLoop.vue?vue&type=template&id=25338a2c&", function () {
      api.rerender('25338a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconLoop.vue"
export default component.exports